import React from 'react';
import { Box, Container, Typography, Button, Grid, useTheme, IconButton } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Navbar from "./layout/Navbar";
import Footer from './layout/Footer';
import { useNavigate } from "react-router-dom";

const MainPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const sliderContent = [
    {
      title: "Eco-Friendly Solutions",
      subtitle: "Discover Our Latest Products",
      image: "https://en.ohmycream.com/cdn/shop/files/2025_01_OMC0260_DERMALOGICA_0_Home_88d58b3d-deca-4a20-8147-36250c5899f1_1000x.jpg?v=1739453315",
      cta: "Learn More"
    },
    {
      title: "Eco-Friendly Solutions",
      subtitle: "Sustainable Living Starts Here",
      image: "https://en.ohmycream.com/cdn/shop/files/2025_02_GOODIEBAG_Home_1000x.jpg?v=1738746735",
      cta: "Learn More"
    }
  ];

  return (
    <>
      <Navbar/>
      <Box sx={{ backgroundColor: theme.palette.background.default }}>
        {/* Enhanced Hero Slider */}
        <Box sx={{ 
          position: 'relative',
          height: { xs: '70vh', md: '80vh' },
          mb: 8
        }}>
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 6000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
        
            style={{
              '--swiper-pagination-color': '#2FA8EF',
              '--swiper-pagination-bullet-inactive-color': '#1E7CB7',
              '--swiper-navigation-color': '#ffffff',
              '--swiper-navigation-size': '32px'
            }}
          >
            {sliderContent.map((slide, index) => (
              <SwiperSlide key={index}>
                <Box sx={{
                  position: 'relative',
                  height: { xs: '70vh', md: '80vh' },
                  backgroundImage: `linear-gradient(
                    rgba(30, 124, 183, 0.4), /*  #1976d2 at 40% opacity (darker shade) */
                    rgba(47, 168, 239, 0.6)  /* #2FA8EF at 60% opacity (base color) */
                  ), url(${slide.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <Container maxWidth="lg">
                    <Box sx={{ 
                      color: 'white',
                      maxWidth: '800px',
                      textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                      position: 'relative',
                      zIndex: 2
                    }}>
                      <Typography variant="h2" component="h1" gutterBottom sx={{
                        fontWeight: 800,
                        color: '#2FA8EF',
                        mb: 3,
                        textShadow: 
                        '1px 1px 4px rgba(0,0,0,0.4), -1px -1px 4px rgba(255,255,255,0.2)',                      
                        fontSize: { xs: '2rem', md: '3rem' }
                      }}>
                        {slide.title}
                      </Typography>
                      <Typography variant="h4" sx={{
                        fontWeight: 400,
                        mb: 4,
                        lineHeight: 1.3,
                        fontSize: { xs: '1.5rem', md: '2rem' }
                      }}>
                        {slide.subtitle}
                      </Typography>
                      {/* <Button variant="contained" sx={{
                        backgroundColor: '#1E7CB7',
                        '&:hover': { 
                          backgroundColor: '#1E7CB7',
                          transform: 'scale(1.05)'
                        },
                        px: 4,
                        py: 2,
                        borderRadius: '50px',
                        transition: 'all 0.3s ease',
                        fontSize: '1.1rem'
                      }}>
                        {slide.cta}
                      </Button> */}
                    </Box>
                  </Container>
                </Box>
              </SwiperSlide>
            ))}
            {/* <Box className="swiper-button-prev" sx={{
              '&::after': { display: 'none' },
              left: '30px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
            }}> */}
              {/* <ChevronLeft sx={{ color: 'white', fontSize: '2rem' }} />
            </Box> */}
            {/* <Box className="swiper-button-next" sx={{
              '&::after': { display: 'none' },
              right: '30px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
            }}>
              <ChevronRight sx={{ color: 'white', fontSize: '2rem' }} />
            </Box> */}
          </Swiper>
        </Box>

        {/* Enhanced About Section */}
        <Container maxWidth="lg" sx={{ mb: 8 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h3" gutterBottom sx={{
                color: '#1E7CB7',
                fontWeight: 700,
                mb: 3,
                lineHeight: 1.2
              }}>
                We Are Elite MagneSSa
              </Typography>
              <Typography variant="body1" paragraph sx={{
                color: '#555',
                fontSize: '1.1rem',
                lineHeight: 1.8,
                mb: 3
              }}>
                We believe wellbeing of people is vital. We are not just another supplement company. 
                We work for a generation that wants more - more quality, more transparency, 
                more sustainability, and more taste.
              </Typography>
              <Button variant="outlined" 
              onClick={() => navigate("/about-us")}
              sx={{
                borderColor: '#2FA8EF',
                color: '#2FA8EF',
                '&:hover': { 
                  backgroundColor: '#2FA8EF11',
                  borderColor: '#7aa738'
                },
                px: 4,
                py: 1.5,
                borderRadius: '8px'

              }}>
                Learn More
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{
                height: 400,
                borderRadius: 4,
                backgroundImage: 'url(https://images.businessnewsdaily.com/app/uploads/2022/04/04081556/1554240570.jpeg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                boxShadow: 3,
                position: 'relative',
                overflow: 'hidden',
                '&:hover img': {
                  transform: 'scale(1.05)'
                }
              }}>
                <Box component="img" 
                  src="https://images.businessnewsdaily.com/app/uploads/2022/04/04081556/1554240570.jpeg"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease'
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>




  {/* Enhanced product about Section */}
  <Container maxWidth="lg" sx={{ mb: 8 }}>
          <Grid container spacing={6} alignItems="center">



          <Grid item xs={12} md={6}>
              <Box sx={{
                height: 400,
                borderRadius: 4,
                backgroundImage: 'url(https://www.shipbob.com/uk/wp-content/uploads/sites/32/2022/07/PRODUCT-RANGE.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                boxShadow: 3,
                position: 'relative',
                overflow: 'hidden',
                '&:hover img': {
                  transform: 'scale(1.05)'
                }
              }}>
                <Box component="img" 
                  src="https://www.shipbob.com/uk/wp-content/uploads/sites/32/2022/07/PRODUCT-RANGE.jpg"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease'
                  }}
                />
              </Box>
            </Grid>

            
            <Grid item xs={12} md={6}>
              <Typography variant="h3" gutterBottom sx={{
                color: '#1E7CB7',
                fontWeight: 700,
                mb: 3,
                lineHeight: 1.2
              }}>
                Our Products
              </Typography>
              <Typography variant="body1" paragraph sx={{
                color: '#555',
                fontSize: '1.1rem',
                lineHeight: 1.8,
                mb: 3
              }}>
               Elite MagneSSa delivers safe, effective, nutritional supplements, environment friendly, cruelty free home care and personal products to help you on your journey towards your health you. We believe being healthy is being happy.
              </Typography>
              
            </Grid>
           




          </Grid>
        </Container>



        {/* Enhanced New Arrivals Section */}
        <Box sx={{ backgroundColor: '#f9f9f9', py: 8 }}>
          <Container maxWidth="lg">
            <Box sx={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 6
            }}>
              <Typography variant="h3" sx={{
                color: '#1E7CB7',
                fontWeight: 700,
                lineHeight: 1.2
              }}>
                New Arrivals
              </Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <IconButton className="swiper-new-prev" sx={{
                  backgroundColor: '#1E7CB7',
                  '&:hover': { backgroundColor: '#2a604a' }
                }}>
                  <ChevronLeft sx={{ color: 'white' }} />
                </IconButton>
                <IconButton className="swiper-new-next" sx={{
                  backgroundColor: '#1E7CB7',
                  '&:hover': { backgroundColor: '#2a604a' }
                }}>
                  <ChevronRight sx={{ color: 'white' }} />
                </IconButton>
              </Box>
            </Box>
            
            <Swiper
              slidesPerView={4}
              spaceBetween={30}
              modules={[Navigation, Autoplay]}
              autoplay={{ delay: 4000 }}
              navigation={{
                nextEl: '.swiper-new-next',
                prevEl: '.swiper-new-prev',
              }}
              breakpoints={{
                320: { slidesPerView: 1 },
                600: { slidesPerView: 2 },
                900: { slidesPerView: 3 },
                1200: { slidesPerView: 4 }
              }}
            >
              {[1,2,3,4,5].map((item) => (
                <SwiperSlide key={item}>
                  <Box sx={{
                    borderRadius: 4,
                    overflow: 'hidden',
                   
                    transition: 'transform 0.3s',
                    '&:hover': { 
                      transform: 'translateY(-5px)',
                      '& .product-info': {
                        opacity: 1,
                        transform: 'translateY(0)'
                      }
                    },
                    position: 'relative'
                  }}>
                    <Box sx={{
                      height: 400,
                      backgroundColor: '#eee',
                      backgroundImage: 'url(https://www.elitemagnessa.com/assets/img/productslider/1.png)',
                      backgroundSize: 'cover',
                      position: 'relative'
                    }}>
                      {/* <Box className="product-info" sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: 'rgba(255,255,255,0.9)',
                        p: 3,
                        opacity: 0,
                        transform: 'translateY(20px)',
                        transition: 'all 0.3s ease'
                      }}> */}
                        {/* <Typography variant="h6" sx={{ 
                          color: '#1E7CB7',
                          fontWeight: 600,
                          mb: 1
                        }}>
                          New Product {item}
                        </Typography> */}
                        {/* <Button variant="contained" sx={{
                          backgroundColor: '#2FA8EF',
                          '&:hover': { backgroundColor: '#7aa738' },
                          px: 3,
                          py: 1,
                          borderRadius: '8px'
                        }}>
                          View Details
                        </Button> */}
                      </Box>
                    </Box>
                  {/* </Box> */}
                </SwiperSlide>
              ))}
            </Swiper>
          </Container>
        </Box>
      </Box>
      <Footer/>
    </>
  );
};

export default MainPage;